export default __webpack_public_path__ + "static/media/rockClimbing.20497b43.jpg";